import content from "../../Content/content.js";

export const CARD = [
    {
      key: "workshop1",
      header: content.workshops.workshopsCalendar.test1Header,
      workshopNum: "1.",
      date: "SEP 23 2023",
      startTime: "6:00 PM",
      endTime: "8:00 PM",
      topic1: "Intro to SQL",
      topic2: "Data Analysis with Python",
    },
    {
        key: "workshop2",
        header: content.workshops.workshopsCalendar.test2Header,
        workshopNum: "2.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "workshop3",
        header: content.workshops.workshopsCalendar.test3Header,
        workshopNum: "3.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "workshop4",
        header: content.workshops.workshopsCalendar.test4Header,
        workshopNum: "4.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "workshop5",
        header: content.workshops.workshopsCalendar.test4Header,
        workshopNum: "5.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "workshop6",
        header: content.workshops.workshopsCalendar.test4Header,
        workshopNum: "6.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "workshop7",
        header: content.workshops.workshopsCalendar.test4Header,
        workshopNum: "7.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "workshop8",
        header: content.workshops.workshopsCalendar.test4Header,
        workshopNum: "8.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "workshop9",
        header: content.workshops.workshopsCalendar.test4Header,
        workshopNum: "9.",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
      {
        key: "pitchDay",
        header: content.workshops.workshopsCalendar.test4Header,
        workshopNum: "Pitch Day",
        date: "SEP 23 2023",
        startTime: "6:00 PM",
        endTime: "8:00 PM",
        topic1: "Intro to SQL",
        topic2: "Data Analysis with Python",
      },
];
